








































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { MemberType } from "@/shared/types";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    Button,
    RadioButton
  }
})
export default class EditFamilyMember extends Vue {

  themeStore = useThemeStore();

  @Prop({ required: true })
  member: any;

  @Prop({ required: true })
  onSave: () => void;

  @Prop()
  toggleClose: () => void;

  @Prop()
  conditions: string[];

  @Prop()
  isNew: boolean;

  @Prop()
  show: { value: boolean };

  $validator: Validator;
  MemberType = MemberType;

  get title () {
    return `${this.isNew ? "Add" : "Edit"} Dependent`;
  }

  get validateBirthYear () {
    const federalAgeLimit = 26;
    const currentYear = new Date().getFullYear();

    if (this.member.memberType !== MemberType.Child) {
      return { required: true };
    }

    return {
      required: true,
      min_value: currentYear - federalAgeLimit,
      max_value: currentYear
    };
  }

  get isSubmitEnabled () {
    return this.isValid;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.onSave();
    });
  }
}
